import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const CurrencyContext = createContext(null);

// Fallback rates if API unreachable
const FALLBACK = { EUR: 1, USD: 1.08, MGA: 4950 };

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    if (typeof window === "undefined") return "EUR";
    return localStorage.getItem("currency") || "EUR";
  });
  const [rates, setRates] = useState(FALLBACK);

  useEffect(() => {
    api.get("/exchange-rates").then((r) => setRates(r.data.rates)).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("currency", c);
  };

  const convert = (amountInEur) => amountInEur * (rates[currency] ?? 1);

  const format = (amountInEur) => {
    const converted = convert(amountInEur);
    if (currency === "MGA") {
      // Ariary: no decimals, 'Ar' suffix
      const val = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.round(converted));
      return `${val} Ar`;
    }
    const opts = { style: "currency", currency, maximumFractionDigits: 0 };
    return new Intl.NumberFormat(currency === "USD" ? "en-US" : "fr-FR", opts).format(converted);
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convert, format, rates }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
